import React, { useState, FC, createContext } from 'react';
import { STORAGE_KEY_HIDDEN_MODE } from '@/constants/storage';
import { getItem } from '@/utils';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const HiddenContext = createContext({ isHiddenMode: false, setIsHiddenMode: (hiddenMode: boolean): void => {} });

const HiddenProvider: FC = ({ children }) => {
  const initIsGhostMode = process.env.REACT_APP_EFC ? getItem(STORAGE_KEY_HIDDEN_MODE) === 'true' || false : false;
  const [isHiddenMode, setIsHiddenMode] = useState<boolean>(initIsGhostMode);

  return (
    <HiddenContext.Provider value={{ isHiddenMode, setIsHiddenMode }}>
      {children}
    </HiddenContext.Provider>
  );
};

export default HiddenProvider;
